import { createContext } from "react";

export const PromotionsState = createContext();
PromotionsState.displayName = "PromotionsState";